import { ReactNode, useCallback } from 'react';

import { Notification, useToastDispatchContext } from './ToastProvider';

export function useToast(): (message: ReactNode | string, type?: Notification['type']) => void {
  const dispatch = useToastDispatchContext();

  const push = useCallback(
    (message: ReactNode | string, type: Notification['type'] = 'success') => {
      if (dispatch) {
        dispatch({
          type: 'PUSH',
          payload: {
            type,
            message,
          },
        });
      }
    },
    [dispatch],
  );

  return push;
}
